import {
    Stethoscope,
    FileCheck2,
    Plane,
    Hotel,
    BedDouble,
    PlaneTakeoff,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export const HowWeDoIt = () => {
    const { t } = useTranslation();

    const STEPS = [
        {
            n: "01",
            key: "step1",
            icon: Stethoscope,
            span: "md:col-span-5 lg:col-span-7",
            tone: "bg-brand-700 text-white",
        },
        {
            n: "02",
            key: "step2",
            icon: FileCheck2,
            span: "md:col-span-3 lg:col-span-5",
            tone: "bg-white text-stone-900",
        },
        {
            n: "03",
            key: "step3",
            icon: Plane,
            span: "md:col-span-3 lg:col-span-4",
            tone: "bg-orange-100 text-stone-900",
        },
        {
            n: "04",
            key: "step4",
            icon: Hotel,
            span: "md:col-span-5 lg:col-span-4",
            tone: "bg-white text-stone-900",
        },
        {
            n: "05",
            key: "step5",
            icon: BedDouble,
            span: "md:col-span-4 lg:col-span-4",
            tone: "bg-stone-900 text-white",
        },
        {
            n: "06",
            key: "step6",
            icon: PlaneTakeoff,
            span: "md:col-span-8 lg:col-span-12",
            tone: "bg-brand-50 text-stone-900",
        },
    ];

    return (
        <section
            id="process"
            data-testid="how-we-do-it-section"
            className="relative py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-3">
                            {t("process.eyebrow")}
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 max-w-2xl leading-[1.05]">
                            {t("process.title")}
                        </h2>
                    </div>
                    <p className="md:max-w-sm text-stone-600">
                        {t("process.subtitle")}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-4">
                    {STEPS.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.n}
                                data-testid={`process-step-${s.n}`}
                                className={`${s.span} ${s.tone} rounded-3xl p-7 md:p-8 relative overflow-hidden group transition-all hover:-translate-y-1 shadow-sm border border-black/5`}
                            >
                                <div className="flex items-start justify-between mb-8">
                                    <div className="h-12 w-12 rounded-2xl bg-black/5 flex items-center justify-center backdrop-blur-sm">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <div className="font-display text-3xl font-bold opacity-30">
                                        {s.n}
                                    </div>
                                </div>
                                <h3 className="font-display text-xl md:text-2xl font-semibold leading-tight mb-2">
                                    {t(`process.${s.key}_title`)}
                                </h3>
                                <p className="text-sm md:text-base opacity-80 leading-relaxed max-w-md">
                                    {t(`process.${s.key}_desc`)}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
